<template>
  <div class="w-100 p-2 mt-2">
    <page-header :name="'Platform wallet'">
      <b-icon-sliders class="mr-2"></b-icon-sliders> {{ $t('page.title.configuration_managment') }}
      <template v-slot:right>
        <b-button @click="addNew()" size="sm" variant="success">{{$t('btn.add_config')}}</b-button>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('page.filters') }}
      </template>
      <template v-slot:content>
        <div class="filters sygni-grid security-group">
          <div class="row">
            <div class="col-6">
              <filter-input
                  :filter-query="filterQuery"
                  filter-operator="like"
                  filter-name="config_key"
                  :label="$t('filters.label.config_key')"
                  :placeholder="$t('filters.placeholder.config_key')">
              </filter-input>
            </div>
            <div class="col-6">
              <filter-input
                  :filter-query="filterQuery"
                  filter-operator="like"
                  filter-name="value"
                  :label="$t('filters.label.value_phrase')"
                  :placeholder="$t('filters.placeholder.value_phrase')">
              </filter-input>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
      </template>
    </page-card>
    <page-card>
      <template v-slot:header>
        {{ $t('page.list' )}}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>

          <div class="table-responsive">
            <b-table striped show-empty
                     :empty-text="$t('table.no_results')"
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined
                     :sort-by.sync="orderColumn"
                     :sort-desc.sync="orderDirection"
                     :no-local-sorting="true"
                     :items="items"
                     :fields="fields">
              <template #cell(created_at)="data">
                <div v-if="data.item.created_at" class="ml-2">
                  {{ data.item.created_at | dateFormat('YYYY-MM-DD HH:mm') }}
                </div>
              </template>
              <template #cell(updated_at)="data">
                <div v-if="data.item.updated_at" class="ml-2">
                  {{ data.item.updated_at | dateFormat('YYYY-MM-DD HH:mm') }}
                </div>
              </template>
              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button
                      variant="success" size="sm"
                      @click="editItem(data.item)"
                  >
                    {{$t('table.btn.edit')}}
                  </b-button>
                  <b-button
                      v-required-role="'ROLE_BACKOFFICE_GROUP_DELETE'"
                      variant="danger" size="sm"
                      @click="deleteItem(data.item)">
                    {{$t('table.btn.delete')}}
                  </b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('state.loading')}}</strong>
                </div>
              </template>
            </b-table>
          </div>

          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
        </div>
      </template>
    </page-card>
  </div>
</template>

<script>
import FilterInput from "../../components/grid/filters/FilterInput";
import GridMixin from '../../components/grid/GridMixin';
import CreateConfigurationModal from "./CreateConfigurationModal";
import axios from "axios";
import alertify from 'alertifyjs';
import GridPagination from "../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../components/page/PageHeader";
import PageCard from "../../components/page/PageCard";
import Vue from "vue";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    PageHeader,
    FilterInput,
    GridPagination,
  },
  data() {
    return {
      gridGetUrl: '/api/config/configuration',
      orderColumn: 'id',
      orderDirection: false,
      fields: [
        {key: 'config_key', label: this.$t('table.header.config_key')},
        {key: 'updated_at', label: this.$t('table.header.updated_at'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions') }
      ],
      items: [],
      createModalInstance: null,
    };
  },
  methods: {
    editItem(item) {
      const
          ModalConstructor = Vue.extend(CreateConfigurationModal),
          modal = new ModalConstructor({parent: this});
      modal.item = item;

      modal.$mount();
    },
    loadItems() {
      this.isBusy = true;
      let offset = this.perPage * (this.currentPage - 1);
      let fullUrl = this.gridGetUrl + '?limit='
          + this.perPage
          + '&offset=' + offset
          + this.createFilterQuery()
          + this.createSortQuery();

      axios.get(fullUrl)
          .then(response => {
            this.items = response.data.items;
            this.totalCount = response.data.totalCount;
            this.isBusy = false;
          })
          .catch(error => {
            console.log(error);
          });
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Configuration: ' + item.config_key, {
        title: 'Are you sure to delete configuration?',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        okVariant: 'danger'
      })
      .then(value => {
        if (value) {
          console.log(item);
          axios.delete(`/api/config/configuration/${item.config_key}/${item.config_group}`)
              .then(() => {
                this.loadItems();
              })
              .catch( () => {
                alertify.error('Group can not be deleted! Remove users from group first.');
              });
        }
      });
    },
    addNew() {
      const
          ModalConstructor = Vue.extend(CreateConfigurationModal),
          modal = new ModalConstructor({parent: this});

      modal.$mount();
    },
    openModal() {
      let ModalConstructor;
      if (!this.createModalInstance) {
        ModalConstructor = Vue.extend(CreateConfigurationModal)
        this.createModalInstance = new ModalConstructor({parent: this});
        this.createModalInstance.$mount();
        this.createModalInstance.openModal();
        this.createModalInstance.$on('savedConfiguration', () => {
          this.loadItems();
        });
      } else {
        this.createModalInstance.openModal();
      }
    }
  }
}
</script>
